var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-badge",class:_vm.color ? `c-badge--${_vm.color}` : ''},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }